import OriginalQuestion from '../../../api/v2/models/question'
import EditorQuersion from "../../models/Question"
import QuestionComparison from './QuestionComparison';

export default class Comparison {
    readonly questionComparisons: QuestionComparison[]

    constructor(readonly originalQuestions: OriginalQuestion[], readonly editorQuersions: EditorQuersion[]){
        const originalLength = originalQuestions.length
        const editorLength = editorQuersions.length

        const minLength = originalLength < editorLength ? originalLength : editorLength

        this.questionComparisons = []
        for (let index = 0; index < minLength; index++) {
            const compareQuestionResult = this.compareQuestion(this.originalQuestions[index], this.editorQuersions[index])
            this.questionComparisons.push(compareQuestionResult)
        }

        // 問題削除された
        if (originalLength > minLength) {
            for (let index = minLength; index < originalLength; index++) {
                const compareQuestionResult = this.compareQuestion(originalQuestions[index], null)
                this.questionComparisons.push(compareQuestionResult)
            }
        }

        // 問題削除された
        if (editorLength > minLength) {
            for (let index = minLength; index < editorLength; index++) {
                const compareQuestionResult = this.compareQuestion(null, editorQuersions[index])
                this.questionComparisons.push(compareQuestionResult)
            }
        }
    }

    private compareQuestion(originalQuestion: OriginalQuestion | null, editorQuersion: EditorQuersion | null): QuestionComparison{
        return new QuestionComparison(originalQuestion, editorQuersion)
    }
    
    get isSame() : boolean {
        return this.questionComparisons.every(item => item.isSame)
    }
}